import { render, staticRenderFns } from "./LooxSettings.vue?vue&type=template&id=3b64fc5c&scoped=true&"
import script from "./LooxSettings.vue?vue&type=script&lang=js&"
export * from "./LooxSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64fc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b64fc5c')) {
      api.createRecord('3b64fc5c', component.options)
    } else {
      api.reload('3b64fc5c', component.options)
    }
    module.hot.accept("./LooxSettings.vue?vue&type=template&id=3b64fc5c&scoped=true&", function () {
      api.rerender('3b64fc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Integrations/loox/LooxSettings.vue"
export default component.exports